module.exports = __webpack_public_path__ + "img/health-pills.43fe9a27.jpg";